module.exports = __webpack_public_path__ + "static/08-daafcbcef8b20c4a6aa3dceadac52369.jpg";